import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, vModelText as _vModelText, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67b7f3c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bug-header" }
const _hoisted_2 = { class: "footnote" }
const _hoisted_3 = { class: "bug-header-right" }
const _hoisted_4 = {
  key: 0,
  class: "bug-header-github"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "bug-expanded"
}
const _hoisted_12 = {
  key: 0,
  class: "bug-dev-comment"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "footnote" }, "Developer comment", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "button-save-green",
  type: "submit",
  value: "Save",
  required: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "button-save-green",
  type: "submit",
  value: "Save",
  required: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_UserIconName = _resolveComponent("UserIconName")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(`wrapper-bugs-list-item ${
      _ctx.updatedBug.status === _ctx.statusResolved ? 'resolved' : ''
    }`)
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.updatedBug.title), 1),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.creationDate), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.updatedBug.status !== _ctx.statusOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(), _createElementBlock("svg", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.githubClicked && _ctx.githubClicked(...args))),
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24"
                    }, _hoisted_6))
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("select", {
                class: "bug-status",
                value: _ctx.updatedBug.status,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updatedBug.status) = $event)),
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateBug && _ctx.updateBug(...args)))
              }, [
                _createElementVNode("option", { value: _ctx.statusOpen }, "Open", 8, _hoisted_8),
                _createElementVNode("option", { value: _ctx.statusInProgress }, "In progress", 8, _hoisted_9),
                _createElementVNode("option", { value: _ctx.statusResolved }, "Resolved", 8, _hoisted_10)
              ], 40, _hoisted_7), [
                [_vModelSelect, _ctx.updatedBug.status]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(`icon ${_ctx.expand ? 'active' : ''}`)
              }, [
                _createVNode(_component_ChevronRightIcon, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expand = !_ctx.expand))
                })
              ], 2)
            ])
          ]),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (_ctx.expand)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalDevComment = true))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.updatedBug.description) + " ", 1),
                      (_ctx.updatedBug.devComment.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _hoisted_13,
                            _hoisted_14,
                            _createTextVNode(" " + _toDisplayString(_ctx.updatedBug.devComment), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_router_link, {
                        to: `/Friend/${_ctx.updatedBug.reporter}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UserIconName, {
                            name: _ctx.author.displayName,
                            "profile-picture": _ctx.author.profilePicture
                          }, null, 8, ["name", "profile-picture"])
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 2)),
    _createVNode(_component_Modal, {
      "is-open": _ctx.modalGitHub,
      onOnCloseClicked: _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalGitHub = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateBug && _ctx.updateBug(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.updatedBug.githubLink) = $event)),
            placeholder: "Github link",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.updatedBug.githubLink]
          ]),
          _hoisted_15
        ], 32)
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_Modal, {
      "is-open": _ctx.modalDevComment,
      onOnCloseClicked: _cache[10] || (_cache[10] = ($event: any) => (_ctx.modalDevComment = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateBug && _ctx.updateBug(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.updatedBug.devComment) = $event)),
            placeholder: "comment"
          }, null, 512), [
            [_vModelText, _ctx.updatedBug.devComment]
          ]),
          _hoisted_16
        ], 32)
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}